<template>
  <div class="Lib">
    <div class="PageZg">{{ title }}</div>

    <CardPreviews :cards="cards"></CardPreviews>

    <div class="Fraza">Вместе каждый может больше!</div>
  </div>
</template>

<script>
import CardPreviews from "@/components/CardPreviews.vue";
import { mapGetters } from 'vuex';

export default {
  components: {
    CardPreviews
  },
  props: {
    title: String,
    cards: Array
  },
};
</script>
